module.exports = __webpack_public_path__ + "assets/img/season-code-04-999b3de1.png";